import {getUTCDateTime} from './getUTCDateTime';

const MONTHS_IN_YEAR = 12;

const EDITABLE_MONTHS_BEFORE_CURRENT = 1;

export const TASK_RETENTION_IN_MONTHS = 12;

export const TASK_ARCHIVE_KEY_PREFIX = 'tasks';
export const TASK_ARCHIVE_MONTHS_KEY_PREFIX = 'months';
export const TASK_ARCHIVE_EXPORTS_KEY_PREFIX = 'exports';

export const getResidentTaskArchivePrefix = (residentId: string): string =>
  `${TASK_ARCHIVE_KEY_PREFIX}/resident_${residentId}/`;

export const getResidentTaskArchiveKey = (
  residentId: string,
  month: string
): string => `${getResidentTaskArchivePrefix(residentId)}${month}.json`;

export const getArchivedMonthMarkerKey = (month: string): string =>
  `${TASK_ARCHIVE_MONTHS_KEY_PREFIX}/${month}.json`;

export const isValidArchiveMonth = (month?: string | null): boolean =>
  !!month && /^\d{4}-(0[1-9]|1[0-2])$/.test(month);

export const getMonthOfDate = (date: string): string => date.slice(0, 7);

export const getCurrentMonth = (): string =>
  getMonthOfDate(getUTCDateTime().toISO());

export const shiftMonth = (month: string, offset: number): string => {
  const [year, monthNumber] = month.split('-').map(Number);
  const monthsSinceYearZero =
    year * MONTHS_IN_YEAR + (monthNumber - 1) + offset;
  const shiftedYear = Math.floor(monthsSinceYearZero / MONTHS_IN_YEAR);
  const shiftedMonth = (monthsSinceYearZero % MONTHS_IN_YEAR) + 1;

  return `${String(shiftedYear).padStart(4, '0')}-${String(
    shiftedMonth
  ).padStart(2, '0')}`;
};

export const getEarliestEditableMonth = (): string =>
  shiftMonth(getCurrentMonth(), -EDITABLE_MONTHS_BEFORE_CURRENT);

export const isFrozenMonth = (month: string): boolean =>
  month < getEarliestEditableMonth();

export const isFrozenTaskDate = (date?: string | null): boolean =>
  !!date && isFrozenMonth(getMonthOfDate(date));

export const getFirstDayOfEarliestEditableMonth = (): string =>
  `${getEarliestEditableMonth()}-01`;
